import { registerIconLibrary } from '@solid-design-system/components/dist-versioned';
import { assetPath } from 'src/environments/environment';

export const iconLibrary: string = `default`;
export default iconLibrary;
export const customIconLibrary: string = 'rpt-icons';

// Icons that should be loaded from assets folder, not the cdn
export enum CustomIcons {
  ARROWS_PROCESS = 'arrows-process',
  HOUSE_ARROW_DOWN = 'house-arrow-down',
}

export function registerSolidIconLibraries(): void {
  registerIconLibrary(customIconLibrary, {
    resolver: (name: string) => `${assetPath}/assets/icons/${name}.svg`,

    // We need currentColor as the main color for the icons
    mutator: (svg: Element) => {
      const recoloredElements = {
        currentColorFills: svg.querySelectorAll('[fill="rgb(var(--sd-color-primary, 0 53 142))"], [fill="#fff"]'),
        currentColorStrokes: svg.querySelectorAll('[stroke="rgb(var(--sd-color-primary, 0 53 142))"], [stroke="#fff"]'),
        greenFills: svg.querySelectorAll('[fill="#43b02a"]'),
        greenStrokes: svg.querySelectorAll('[stroke="#43b02a"]'),
      };

      for (const filledElement of recoloredElements.currentColorFills) {
        filledElement.setAttribute('fill', 'currentColor');
      }

      for (const strokedElement of recoloredElements.currentColorStrokes) {
        strokedElement.setAttribute('stroke', 'currentColor');
      }

      for (const filledElement of recoloredElements.greenFills) {
        filledElement.setAttribute('fill', 'rgb(var(--sd-color-accent, 67 176 42) / var(--tw-bg-opacity, 1))');
      }

      for (const strokedElement of recoloredElements.greenStrokes) {
        strokedElement.setAttribute('stroke', 'rgb(var(--sd-color-accent, 67 176 42) / var(--tw-bg-opacity, 1))');
      }

      return svg;
    },
  });
}
